import { AutocompleteSelect } from '../../../shared/components/AutocompleteSelect';
import { TextInput } from '../../../shared/components/TextInput';
import type { BondPayload } from '../api';
import { useEmpresasAtivas } from '../hooks';
import { CONTRACT_KIND_LABELS } from './format';

interface Props {
  value: Partial<BondPayload>;
  onChange: (patch: Partial<BondPayload>) => void;
  errors?: Record<string, string>;
  /** Na edição, empresa, tipo e matrícula não mudam. */
  editing?: boolean;
}

/** Campos do vínculo: empresa, tipo, admissão, contrato e matrícula manual. */
export function BondFields({ value, onChange, errors = {}, editing = false }: Props) {
  const empresas = useEmpresasAtivas();

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
      {!editing && (
        <>
          <AutocompleteSelect
            label="Empresa"
            options={(empresas.data ?? []).map((c) => ({ value: c.id, label: c.tradeName || c.corporateName }))}
            value={value.companyId ?? ''}
            error={errors.companyId}
            onChange={(v) => onChange({ companyId: v })}
          />
          <AutocompleteSelect
            label="Tipo de vínculo"
            options={[{ value: 'clt', label: 'CLT' }, { value: 'pj', label: 'PJ' }]}
            value={value.employmentType ?? ''}
            error={errors.employmentType}
            onChange={(v) => onChange({ employmentType: v as BondPayload['employmentType'] })}
          />
        </>
      )}
      <TextInput
        label="Data de admissão"
        type="date"
        value={value.admissionDate ?? ''}
        error={errors.admissionDate}
        onChange={(e) => onChange({ admissionDate: e.target.value })}
      />
      <AutocompleteSelect
        label="Tipo de contrato"
        options={Object.entries(CONTRACT_KIND_LABELS).map(([v, l]) => ({ value: v, label: l }))}
        value={value.contractKind ?? ''}
        error={errors.contractKind}
        onChange={(v) => onChange({ contractKind: v as BondPayload['contractKind'] })}
      />
      {value.contractKind === 'determinado' && (
        <TextInput
          label="Data final prevista"
          type="date"
          value={value.contractEndDate ?? ''}
          error={errors.contractEndDate}
          onChange={(e) => onChange({ contractEndDate: e.target.value })}
        />
      )}
      {value.contractKind === 'experiencia' && (
        <>
          <TextInput
            label="Fim da experiência"
            type="date"
            value={value.probationEndDate ?? ''}
            error={errors.probationEndDate}
            onChange={(e) => onChange({ probationEndDate: e.target.value })}
          />
          <TextInput
            label="Fim da prorrogação (opcional)"
            type="date"
            value={value.probationExtensionEndDate ?? ''}
            error={errors.probationExtensionEndDate}
            onChange={(e) => onChange({ probationExtensionEndDate: e.target.value })}
          />
        </>
      )}
      {!editing && (
        <TextInput
          label="Matrícula interna (opcional)"
          value={value.internalRegistration ?? ''}
          onChange={(e) => onChange({ internalRegistration: e.target.value })}
        />
      )}
    </div>
  );
}
